/**
 * Product Hotspot Component
 */

if (!customElements.get('product-hotspot')) {
  class ProductHotspot extends HTMLElement {
    constructor() {
      super();
      this.attachEventListeners();
    }

    attachEventListeners() {
      this.addEventListener('click', (e) => {
        const tooltip = this.querySelector('.product-hotspot__tooltip');

        if (tooltip && tooltip.contains(e.target)) {
          e.preventDefault();
          e.stopPropagation();
          this.navigateToProduct();
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        this.toggleActive();
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target) && this.classList.contains('active')) {
          this.classList.remove('active');
          this.resetTooltipPosition();
        }
      });
    }

    toggleActive() {
      const container = this.closest('product-hotspot-container');
      if (container) {
        container.querySelectorAll('product-hotspot.active').forEach(hotspot => {
          if (hotspot !== this) {
            hotspot.classList.remove('active');
            hotspot.resetTooltipPosition();
          }
        });
      }
      this.classList.toggle('active');

      if (this.classList.contains('active')) {
        requestAnimationFrame(() => this.keepTooltipInViewport());
      } else {
        this.resetTooltipPosition();
      }
    }

    keepTooltipInViewport() {
      const tooltip = this.querySelector('.product-hotspot__tooltip');
      if (!tooltip) return;

      this.resetTooltipPosition();

      const viewportPadding = 12;
      const rect = tooltip.getBoundingClientRect();
      const bounds = this.getVisibleBounds(viewportPadding);
      let shiftX = 0;
      let shiftY = 0;

      if (rect.left < bounds.left) {
        shiftX = bounds.left - rect.left;
      } else if (rect.right > bounds.right) {
        shiftX = bounds.right - rect.right;
      }

      if (rect.top < bounds.top) {
        shiftY = bounds.top - rect.top;
      } else if (rect.bottom > bounds.bottom) {
        shiftY = bounds.bottom - rect.bottom;
      }

      tooltip.style.setProperty('--hotspot-tooltip-shift-x', `${shiftX}px`);
      tooltip.style.setProperty('--hotspot-tooltip-shift-y', `${shiftY}px`);
    }

    getVisibleBounds(padding) {
      const bounds = {
        left: padding,
        top: padding,
        right: window.innerWidth - padding,
        bottom: window.innerHeight - padding
      };

      let ancestor = this.parentElement;
      while (ancestor && ancestor !== document.body) {
        const styles = window.getComputedStyle(ancestor);
        const ancestorRect = ancestor.getBoundingClientRect();

        if (styles.overflowX !== 'visible') {
          bounds.left = Math.max(bounds.left, ancestorRect.left + padding);
          bounds.right = Math.min(bounds.right, ancestorRect.right - padding);
        }

        if (styles.overflowY !== 'visible') {
          bounds.top = Math.max(bounds.top, ancestorRect.top + padding);
          bounds.bottom = Math.min(bounds.bottom, ancestorRect.bottom - padding);
        }

        ancestor = ancestor.parentElement;
      }

      return bounds;
    }

    resetTooltipPosition() {
      const tooltip = this.querySelector('.product-hotspot__tooltip');
      if (!tooltip) return;

      tooltip.style.removeProperty('--hotspot-tooltip-shift-x');
      tooltip.style.removeProperty('--hotspot-tooltip-shift-y');
    }

    navigateToProduct() {
      const url = this.getAttribute('data-product-url');
      if (url) {
        window.location.href = url;
      }
    }
  }

  customElements.define('product-hotspot', ProductHotspot);
}

if (!customElements.get('product-hotspot-container')) {
  class ProductHotspotContainer extends HTMLElement {}
  customElements.define('product-hotspot-container', ProductHotspotContainer);
}
